import { render, staticRenderFns } from "./ProjectTasks.vue?vue&type=template&id=4e01550e"
import script from "./ProjectTasks.vue?vue&type=script&lang=ts"
export * from "./ProjectTasks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports